import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.975 3.1C1.975 2.47868 2.47868 1.975 3.1 1.975H10.3C10.9213 1.975 11.425 2.47868 11.425 3.1V10.3C11.425 10.9213 10.9213 11.425 10.3 11.425H3.1C2.47868 11.425 1.975 10.9213 1.975 10.3V3.1ZM3.1 0.625C1.7331 0.625 0.625 1.7331 0.625 3.1V10.3C0.625 11.6669 1.7331 12.775 3.1 12.775H4.225V13.9C4.225 15.2628 5.33721 16.375 6.7 16.375H13.9C15.2628 16.375 16.375 15.2628 16.375 13.9V6.7C16.375 5.33721 15.2628 4.225 13.9 4.225H12.775V3.1C12.775 1.7331 11.6669 0.625 10.3 0.625H3.1ZM12.775 5.575V10.3C12.775 11.6669 11.6669 12.775 10.3 12.775H5.575V13.9C5.575 14.5172 6.08279 15.025 6.7 15.025H13.9C14.5172 15.025 15.025 14.5172 15.025 13.9V6.7C15.025 6.08279 14.5172 5.575 13.9 5.575H12.775Z",
      fill: "#334155"
    }, null, -1)
  ]))]))
}
export default { render: render }